<ng-template #userRow let-user>
  <td class="user-cell">
    <div class="user-cell__primary">{{ user.displayName || user.userName }}</div>
    <div class="user-cell__secondary">
      @if (user.emailMasked) {
        <span>{{ user.emailMasked }}</span>
      }
      <span class="user-cell__username">{{ '@' + user.userName }}</span>
    </div>
  </td>
  <td class="col-narrow">
    <span class="role-pill">{{ 'app.admin.users.roles.' + user.role | translate }}</span>
  </td>
  <td class="col-center">
    <app-onboarding-status-badge [status]="user.onboardingStatus" />
  </td>
  <td class="col-progress">
    <div class="progress-cell">
      <div class="progress-cell__bar" aria-hidden="true">
        <span
          class="progress-cell__fill"
          [style.width.%]="user.onboardingProgressPercent"
        ></span>
      </div>
      <span class="progress-cell__label">
        {{ user.onboardingProgressPercent }}%
      </span>
    </div>
  </td>
  <td class="col-center">
    <div class="account-flags">
      @if (user.isActive) {
        <span class="account-flag account-flag--active">
          {{ 'app.admin.users.active' | translate }}
        </span>
      } @else {
        <span class="account-flag account-flag--inactive">
          {{ 'app.admin.users.inactive' | translate }}
        </span>
      }
      @if (user.verified) {
        <span class="account-flag account-flag--verified">
          {{ 'app.admin.users.verified' | translate }}
        </span>
      }
      @if (user.createdByParent) {
        <span class="account-flag account-flag--parent">
          {{ 'app.admin.users.parentCreated' | translate }}
        </span>
      }
    </div>
  </td>
  <td class="col-narrow date-cell">
    {{ user.creationDate * 1000 | date: 'mediumDate' }}
  </td>
  <td class="col-center col-actions">
    <button type="button" class="row-action" (click)="viewUser.emit(user)">
      {{ 'app.admin.users.viewDetails' | translate }}
    </button>
  </td>
</ng-template>

<app-admin-data-table
  [columns]="columns"
  [rows]="users()"
  [rowTemplate]="userRow"
  [trackByProp]="trackUser"
  variant="desktop-only"
/>
